import { Component, Vue } from "vue-property-decorator";
import VueStore from "@/store/VueStore";
import SeatMappingComponent from "@/components/seatMapping/SeatMapping.vue";
import {
  MstGraphTitlesType,
  MstSeatMappingType,
  SeatSensorStateType,
  SensorAreaSizeItemsType,
  AuthStoreType
} from "@/types/types";
import MstSeatMappingService from "@/services/mst_seat_mapping_service";
import AuthStoreAPI from "@/services/auth_store_service";

@Component({
  components: {
    SeatMappingComponent
  }
})

export default class IndexSeatMapping extends Vue {
  public settingTitle: string = "センサー追加";
  public editSensorAreaFlag: boolean = false;
  public offIconClass: boolean = true;
  public settingArea: boolean = false;
  public seatAreaOverlay: boolean = false;
  public mstGraphs: MstGraphTitlesType[] = [];
  public deviceId: string = "";
  public displayName: string = "";
  public attributes: string[] = [];
  public targetAttribute: string = null;
  public mstSeatMapping: MstSeatMappingType = null;
  public mstSeatMappings: MstSeatMappingType[] = [];
  public selectMstSeatMappingIndex: number = null;
  public selectMstSeatMapping: MstSeatMappingType = null;
  public dispayButton: string = "submit";
  public deleteButton: boolean = false;
  public selectSensor: boolean = false;
  public sensorAreaSize: string = "midium";
  public sensorAreaSizeItems: SensorAreaSizeItemsType[] = [
    {
      label: "小",
      value: "small"
    },
    {
      label: "中",
      value: "midium"
    },
    {
      label: "大",
      value: "large"
    }
  ];
  // 認証情報
  public authStore: AuthStoreType = null;
  public authStoreName: string = "presence_mapping";
  public historyArea: boolean = false;
  public fromTime: string = "";
  public toTime: string = "";

  // 履歴表示
  public historyTitle = "履歴表示";

  public async created() {
    this.historyArea = false;
    this.$parent.$children[0].$data.headerElement = true;
    const userID: string = VueStore.state.userName;
    this.authStore = await AuthStoreAPI.queryFromStoreName(userID, this.authStoreName);

    this.mstSeatMappings = await MstSeatMappingService.queryAll(userID);
  }

  /**
   * ドラッグ可否の切り替え
   */
  public changeEditFlag() {
    this.editSensorAreaFlag = !this.editSensorAreaFlag;
    this.offIconClass = !this.offIconClass;
  }

  /**
   * 設定画面表示
   */
  public displayAddSettingModal() {
    this.settingTitle = "センサー追加";
    this.seatAreaOverlay = true;
    this.settingArea = true;
    this.dispayButton = "submit";
  }

  /**
   * 設定編集画面表示
   * @param mstSeatMapping
   */
  public editSettingModal() {
    this.settingTitle = "センサー設定編集";
    this.selectSensor = true;
    this.seatAreaOverlay = true;
    this.settingArea = true;
    this.dispayButton = "edit";
    this.deleteButton = true;
  }

  /**
   * mappingMaster 選択時処理
   */
  public changeSelectMstSeatMapping() {
    this.selectMstSeatMapping = this.mstSeatMappings[this.selectMstSeatMappingIndex];
    this.deviceId = this.selectMstSeatMapping.device_id;
    this.displayName = (this.selectMstSeatMapping.sensor_state as SeatSensorStateType).displayName;
    this.sensorAreaSize = this.judgeSensorAreaSize((this.selectMstSeatMapping.sensor_state as SeatSensorStateType).height);
  }

  /**
   * 設置画面非表示
   */
  public hiddenSettingModal() {
    this.seatAreaOverlay = false;
    this.deleteButton = false;
    this.selectSensor = false;
    this.historyArea = false;
    this.settingArea = false;
  }

  /**
   * マスター登録
   */
  public async addMstSeatMapping() {
    try {
      this.dispayButton = "sending";
      this.mstSeatMapping = this.initMstSeatMapping();
      await MstSeatMappingService.create(this.mstSeatMapping);
      this.mstSeatMappings.push(this.mstSeatMapping);
      this.dispayButton = "success";
      setTimeout(() => {
        this.dispayButton = "submit";
        this.hiddenSettingModal();
        this.editSensorAreaFlag = true;
        this.offIconClass = false;
      }, 1000);
    } catch (err) {
      console.error(err);
      this.dispayButton = "error";
      setTimeout(() => {
        this.dispayButton = "submit";
      }, 5000);
    }
  }

  /**
   * マスター更新
   */
  public async updateMstSeatMapping() {
    try {
      this.dispayButton = "sending";
      this.setmstSeatMapping();
      await MstSeatMappingService.update(this.selectMstSeatMapping);
      this.dispayButton = "success";
      this.mstSeatMappings[this.selectMstSeatMappingIndex] = this.selectMstSeatMapping;
      this.selectMstSeatMappingIndex = null;
      this.deviceId = null;
      this.displayName = null;
      setTimeout(() => {
        this.dispayButton = "submit";
        this.hiddenSettingModal();
      }, 1000);
    } catch (err) {
      console.error(err);
      this.dispayButton = "error";
      setTimeout(() => {
        this.dispayButton = "edit";
      }, 5000);
    }
  }

  /**
   * マスター削除
   */
  public async deleteMstSeatMapping() {
    try {
      const deleteCheck = confirm("選択中のマスター情報を削除しても良いですか？");
      if (!deleteCheck) {
        this.hiddenSettingModal();
        return;
      }
      await MstSeatMappingService.delete(this.selectMstSeatMapping.user_id, this.selectMstSeatMapping.mapping_id);
      this.mstSeatMappings = await MstSeatMappingService.queryAll(this.selectMstSeatMapping.user_id);
      this.hiddenSettingModal();
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * mapping_idの生成
   */
  public setMappingID(): number {
    if (this.mstSeatMappings.length > 0) {
      const latestMstMapping = this.mstSeatMappings[this.mstSeatMappings.length - 1];
      return latestMstMapping.mapping_id + 1;
    } else {
      return 0;
    }
  }

  /**
   * センサーのサイズ設定
   * @param side
   */
  public setSensorAreaSize(side: string): number {
    switch (this.sensorAreaSize) {
      case "small":
        if (side === "height") {
          return 100;
        } else {
          return 120;
        }
      case "large":
        if (side === "height") {
          return 200;
        } else {
          return 180;
        }
      default:
        if (side === "height") {
          return 150;
        } else {
          return 150;
        }
    }
  }

  public judgeSensorAreaSize(value: number): string {
    switch (value) {
      case 100:
        return "small";
      case 200:
        return "large";
      default:
        return "midium";
    }
  }

  /**
   * seatMappingMaster 初期設定生成
   */
  public initMstSeatMapping(): MstSeatMappingType {
    return {
      user_id: VueStore.state.userName,
      mapping_id: this.setMappingID(),
      device_id: this.deviceId,
      sensor_state: {
        displayName: this.displayName,
        xPosition: 0,
        yPosition: 0,
        width: this.setSensorAreaSize("width"),
        height: this.setSensorAreaSize("height")
      }
    };
  }

  /**
   * mappingMaster 更新生成
   */
  public setmstSeatMapping() {
    const newmstSeatMapping: MstSeatMappingType = this.selectMstSeatMapping;
    const sensorState: SeatSensorStateType = newmstSeatMapping.sensor_state as SeatSensorStateType;
    sensorState.displayName = this.displayName;
    sensorState.width = this.setSensorAreaSize("width");
    sensorState.height = this.setSensorAreaSize("height");
    newmstSeatMapping.sensor_state = sensorState;
    newmstSeatMapping.device_id = this.deviceId;
  }

}
